import {
  Account,
  Currency,
  PermissionEnum,
  Response,
  apiAbortController,
  AccountingJobProps as AccountingJob,
} from '@ui/src';
import api from '../../api/api';
import { Category, Account as ReportsAccount } from '../../hoc/types';

export interface PermissionResponse {
  permissions: PermissionEnum[];
}

export const reportsDictionariesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getReportsCurrencies: build.query<Response<Currency>, void>({
      query: () => ({
        url: '/v1/currencies?active=true&all=true',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getReportsDictionariesAccountsCategories: build.query<
      Response<Category>,
      void
    >({
      query: () => ({
        url: `/v1/accounts-categories?all=true&include=primaryAccounts`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getReportsBaseCurrency: build.query<{ data: Currency }, void>({
      query: () => ({
        url: '/v1/currencies/base',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getReportsTransactionsAccounts: build.query<Response<Account>, string>({
      query: (query) => ({
        url: `/v1/accounts${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getReportsPermissions: build.query<{ data: PermissionResponse }, void>({
      query: () => ({
        url: '/v1/employees/whoami',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getReportsWhitelabel: build.query<
      {
        data: {
          data: {
            value: Record<string, string>;
          };
        };
      },
      void
    >({
      query: () => ({
        url: '/v1/settings/whitelabel',
      }),
    }),
    getReportsAccounts: build.query<Response<ReportsAccount>, string>({
      query: (query) => ({
        url: `/v1/accounts${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getAccountingJobsInProgress: build.query<Response<AccountingJob>, string>({
      query: (query) => ({
        url: `/v1/accounting-jobs${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getAccountingJobsInProgressStates: build.query<
      Response<AccountingJob>,
      string
    >({
      query: (query) => ({
        url: `/v1/accounting-jobs${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useGetReportsCurrenciesQuery,
  useLazyGetReportsBaseCurrencyQuery,
  useLazyGetReportsCurrenciesQuery,
  useLazyGetReportsTransactionsAccountsQuery,
  useLazyGetReportsPermissionsQuery,
  useGetReportsBaseCurrencyQuery,
  useLazyGetReportsWhitelabelQuery,
  useLazyGetReportsAccountsQuery,
  useLazyGetReportsDictionariesAccountsCategoriesQuery,
  useLazyGetAccountingJobsInProgressQuery,
  useLazyGetAccountingJobsInProgressStatesQuery,
} = reportsDictionariesApi;

export const {
  endpoints: {
    getReportsCurrencies,
    getReportsPermissions,
    getReportsBaseCurrency,
    getReportsAccounts,
    getReportsDictionariesAccountsCategories,
    getAccountingJobsInProgress,
    getAccountingJobsInProgressStates,
  },
} = reportsDictionariesApi;
